import React from 'react';
import ContentTemplate from 'web-library/stories/template/ContentTemplate/ContentTemplate';
import TitleHeader from 'web-library/stories/molecule/TitleHeader/TitleHeader';
import ResetPasswordForm from '../../modules/profile/components/ResetPasswordForm';

const ResetPassword = () => (
  <>
    <TitleHeader title="Reset Password" />

    <ContentTemplate>
      <ResetPasswordForm />
    </ContentTemplate>
  </>
);

export default ResetPassword;
